import styled from 'styled-components';

// Constellation Components
import { Text } from '@zillow/constellation';
import { Row } from '@zillow/zrs-comet';

export const StyledRow = styled(Row)`
    flex: initial;
`;

export const StyledUppercaseText = styled(Text)`
    text-transform: uppercase;
`;
